import { render, staticRenderFns } from "./AuthorDetailsAvatarBox.vue?vue&type=template&id=8e4c1e82&scoped=true"
import script from "./AuthorDetailsAvatarBox.vue?vue&type=script&lang=js"
export * from "./AuthorDetailsAvatarBox.vue?vue&type=script&lang=js"
import style0 from "./AuthorDetailsAvatarBox.vue?vue&type=style&index=0&id=8e4c1e82&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e4c1e82",
  null
  
)

export default component.exports